import { GROUP_USER } from '../../config/appGroupConfig';
import {
  CLOSE_LOGIN_MODAL,
  CLOSE_REGISTER_MODAL,
  OPEN_LOGIN_MODAL,
  OPEN_VENDOR_REGISTER_MODAL,
  OPEN_VENUE_REGISTER_MODAL,
} from './constants';

const initialState = {
  loginOpen: false,
  registerOpen: false,
  registerUserRole: null,
};

const homeReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case OPEN_LOGIN_MODAL:
      return { ...state, loginOpen: true };
    case CLOSE_LOGIN_MODAL:
      return { ...state, loginOpen: false };
    case OPEN_VENDOR_REGISTER_MODAL:
      return { ...state, registerOpen: true, registerUserRole: GROUP_USER.VENDOR };
    case OPEN_VENUE_REGISTER_MODAL:
      return { ...state, registerOpen: true, registerUserRole: GROUP_USER.VENUE };
    case CLOSE_REGISTER_MODAL:
      return { ...state, registerOpen: false };
    default:
      return state;
  }
};

export default homeReducer;
